import { Component, EventEmitter, Output } from '@angular/core'

@Component({
    selector: 'app-filter-no-results',
    templateUrl: './filter-no-results.component.html',
})
export class FilterNoResultsComponent {
    @Output() changeFilters = new EventEmitter<void>()
}
